import { FieldsSection } from "@/src/data/allTypes";
import { cleanHtmlEscaping } from "@/src/utils/utils";
import { useRef, useState } from "react";
import { DocumentEditorContent } from "./documentEditor";
import { DocumentEditorToolbar } from "./documentEditorToolbar";

export function VariableInputPicker({
  name,
  toolbarId,
  sections,
  value,
  onChange,
}: {
  name: string;
  toolbarId: string;
  sections: (FieldsSection | null | undefined)[];
  value: string;
  onChange: (newValue: string) => void;
}) {
  const titleRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  let [content, setContent] = useState(value);

  function onValueChange() {
    let newValue = contentRef.current?.innerHTML || "";
    newValue = cleanHtmlEscaping(newValue).trim();

    onChange(newValue);
  }

  return (
    <div
      className="field"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="label">{name}</div>

      <div
        className="input c1-auto gap5 acenter"
        style={{ padding: "5px 5px 5px 15px", minWidth: "150px" }}
      >
        <DocumentEditorContent
          isMini={true}
          titleRef={titleRef}
          currentTitle={""}
          contentRef={contentRef}
          currentContent={content}
          format="a4"
          isHtmlMode={false}
          isTemplate={true}
          patientDocument={null}
          onChange={(newContent) => {
            content = newContent;
            // setContent(newContent);
            onValueChange();
          }}
          onTitleChange={() => {}}
        ></DocumentEditorContent>
        <DocumentEditorToolbar
          onChange={(newContent) => {
            content = newContent;
            // contentRef!.current!.innerHTML = newContent;

            // setContent(newContent);
            onValueChange();
          }}
          contentRef={contentRef}
          toolbarId={toolbarId}
          sections={sections}
          allowedButtons={["variable"]}
          isHtmlMode={false}
          onFormatChange={() => {}}
          patientDocument={null}
        ></DocumentEditorToolbar>
      </div>
    </div>
  );
}
